import { render, staticRenderFns } from "./upgrade-card.vue?vue&type=template&id=f29bbdc8&scoped=true&"
import script from "./upgrade-card.vue?vue&type=script&lang=js&"
export * from "./upgrade-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29bbdc8",
  null
  
)

export default component.exports